<bt-loader [loaderId]="loaderId">
	@if (chips && chips.length) {
		<ng-container>
			<h4 class="margin-bottom">Categories</h4>
			<div class="chips-container">
				@for (chip of chips; track chip) {
					<span class="chip margin-right-small hover">{{ chip.text }}</span>
				}
			</div>
		</ng-container>
	}
	<!-- 
  <ngx-masonry *ngIf="companies.data"
               [options]="{ gutter: 16 }"
               class="margin-top">

    <div ngxMasonryItem
         class="card custom-width margin-bottom"
         *ngFor="let item of companies.dataToView">

      <details open>
        <summary class="hover">
          <div class="flex center">
            <div class="flex-0">
              <div class="picture margin-right"
                   style="background: url('https://via.placeholder.com/150')"></div>
            </div>
            <div class="flex-1">
              <h4 class="margin-bottom-small">{{item.companyName}}</h4>
              @if(item.CategoryName){
                <span class="chip">Fashion</span>
              }
            </div>
            <div class="arrows">
              <i class="fa fa-chevron-down"></i>
              <i class="fa fa-chevron-up"></i>
            </div>
          </div>
        </summary>

        <div class="margin-top">
          @if(item.Description){
            <ng-container>
              <b>Company description</b>
              <div class="margin-bottom">{{item.Comments}}</div>
            </ng-container>
          }
          @if(item.Address){
            <ng-container>
              <b>Address</b>
              <div class="margin-bottom">{{item.Address}}</div>
            </ng-container>
          }
          <div class="align-right">
            <button [disabled]="item.unavailableCompany"
                    (click)="onSendCollaborationRequest(item)">
              <i class="fa fa-paper-plane"></i>{{item.unavailableCompany ? 'Collaboration sent' : 'Send collaboration
              request'}}
            </button>
          </div>
        </div>
      </details>

    </div>

  </ngx-masonry>-->
</bt-loader>
